import { useQuery } from "@tanstack/react-query";
import { getFaqGroupDetails } from "../api/getFaqGroupDetails";

export const useFaqGroupDetailsQuery = (faqGroupId: string) => {
  return useQuery({
    queryKey: ["faqGroups", { faqGroupId }],
    queryFn: async () => {
      return await getFaqGroupDetails(faqGroupId);
    },
    staleTime: 0,
  });
};
